<div class="flex h-[70vh] items-center justify-center px-4">
  <div
    class="dark:bg-secondary-700 flex max-w-md flex-col gap-2 rounded-lg bg-white p-8 text-left shadow">
    <div class="mb-2 flex flex-col gap-2">
      <h1 class="text-2xl font-bold text-gray-800 uppercase dark:text-gray-300">
        Página no encontrada
      </h1>
      <p class="text-sm text-pretty text-gray-500">
        Parece que te has perdido, si se trata de un error puedes contactar al
        soporte o volver al
        <a
          class="text-primary-500 ms-0.5 font-bold hover:underline"
          [routerLink]="['/']">
          inicio.
        </a>
      </p>
    </div>

    <div class="flex gap-2">
      <p-button label="Volver al inicio" (onClick)="goToHome()" />
    </div>

    <p class="mt-3 text-sm text-gray-400 italic dark:text-gray-600">
      404 - Not Found Exeption
    </p>
  </div>
</div>
